module.exports = __webpack_public_path__ + "static/media/tbv-logo-full-color-no-tagline.93246ab7.svg";